import { isDefined } from "@clipboard-health/util-ts";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  List,
  ListItem,
  Skeleton,
  Stack,
} from "@mui/material";
import { ExternalLink, Text } from "@src/lib/ui-react";
import { useEffect, useState } from "react";

import { useGetDocumentZendeskTickets } from "../api/useGetDocumentZendeskTickets";

interface DocumentZendeskTicketsProps {
  documentId?: string;
}

export function DocumentZendeskTickets(props: DocumentZendeskTicketsProps) {
  const { documentId } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [documentId]);

  const { data, isLoading, isError, isSuccess } = useGetDocumentZendeskTickets(
    { documentId: documentId ?? "" },
    { enabled: isDefined(documentId) && isExpanded }
  );

  return (
    <Stack mb={2}>
      <Accordion
        expanded={isExpanded}
        onChange={(_event, expanded) => {
          setIsExpanded(expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Text variant="subtitle2">View related Zendesk tickets</Text>
        </AccordionSummary>
        <AccordionDetails>
          {isLoading && <Skeleton height="4rem" />}
          {isError && <Alert severity="error">Error loading document Zendesk tickets</Alert>}
          {isSuccess && data.data.length === 0 && <Alert severity="info">No related tickets</Alert>}
          {isSuccess && data.data.length > 0 && (
            <List>
              {data.data.map((ticket) => (
                <ListItem key={ticket.id}>
                  <ExternalLink to={ticket.attributes.url}>
                    <Text variant="subtitle2">{ticket.attributes.subject ?? "(No Subject)"}</Text>
                  </ExternalLink>
                </ListItem>
              ))}
            </List>
          )}
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
